import { Timestamp } from 'firebase-tools';
import { TemplateChannels } from './template';
import firebase from 'firebase/compat';

export interface IConversationClickEvent {
  conversation: HLConversationModel;
  isAutoSelectedConversation: boolean;
}

export class HLConversationAgent {
  agentAvatarUrl: string;
  agentId: string;
  agentName: string;
}
export class HLCorp {
  conversation_tags: string[];
  corpId: string;
}
export class HLConversationUserData {
  botFrameworkUserId: string;
  email: string;
  fullName: string;
  firstName: string;
  ipAddress: string;
  lastName: string;
  phoneNumber: string;
}
export class HLConversationModel {
  assignments?: HLConversationAgent[];
  assignmentUserIds?: string[];
  assignmentCount?: number;
  botId: string;
  botName: string;
  channel: HLUserResponseChannels;
  conversationState: object;
  firebaseDocumentId?: string; // access to doc ID when not available in document properties
  fromEmails?: { name: string; address: string }[];
  handover: boolean;
  hierarchyElements: string[];
  id: string;
  lastChannel: TemplateChannels;
  lastMessage?: string;
  lastMessageDate?: Timestamp;
  lastUpdated: Timestamp;
  lastUpdatedString: string;
  messages: ConversationMessageModel[];
  needsAttentionContinue?: boolean;
  needsAttentionInitial?: boolean;
  nodeName?: string;
  status: HLConversationStatus;
  tags: string[];
  tagToolTipText: string;
  toEmailAddresses?: string[];
  touched: boolean;
  user: any;
  userData?: HLConversationUserData;
  userSMS?: string;
  intent?: string;
  campaign?: string;
  esmScore?: number;
  scheduledAppointmentType?: string[];
  unscheduledAppointmentType?: string[];
  appointmentCreationTime?: Timestamp;
}

export class HLConversationNotes {
  createdAt: Timestamp;
  note: string;
  user: HLConversationAgent;
}

export enum HLConversationStatus {
  Read = 'read',
  Unread = 'unread',
}

export type HLUserResponseChannels = 'web' | 'email' | 'directline' | 'facebook' | 'sms';

export class HLTemplateModel {
  name: string;
  id: string;
  botId: string;
  channel: string;
  content: string;
  createdBy: string;
  createdAt: Timestamp;
  lastUpdated: Timestamp;
  tags: string[];
}

export class ConversationMessageModel {
  id: string;
  message: string;
  channel: string;
  userType: string;
  createdAt: Timestamp;
  formattedTime: string;
  preview: string;
  messageType: string;
  nodeName?: string;
  emailSubject?: string;
  emailFrom?: string;
  emailTo?: string;
  userId?: string;
  agentName?: string;
  firebaseDocumentId?: string;
  direction?: 'incoming' | 'outgoing';
  intent?: string;
  dealer?: boolean;

  static addSetNodeLogMessage(message: ConversationMessageModel) {
    const { messageType, agentName, nodeName } = message;
    if (messageType === 'setNode') {
      if (agentName && nodeName) {
        message.message = `${agentName} ${nodeName}`;
      }
    }
    return message;
  }
}

export interface IFirebaseFilterCriteria {
  field: string | firebase.firestore.FieldPath;
  value: any;
  operator: firebase.firestore.WhereFilterOp;
}
